import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BellRing, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { enableWebPush, webPushState } from "../../native/webPush";
import { IS_STORE_BUILD } from "../../config/storeBuild";
import { PushTestButton } from "./PushTestButton";

// تفعيل إشعارات المتصفح/PWA لهذا الجهاز — تُخفى داخل نسخة المتاجر (تستخدم APNS/FCM أصلياً).
export const WebPushToggle = () => {
  const { t } = useTranslation();
  const [state, setState] = useState(webPushState());
  const [busy, setBusy] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  if (IS_STORE_BUILD) return null;

  const enable = async () => {
    setBusy(true);
    try {
      const res = await enableWebPush();
      setState(res.enabled ? "granted" : webPushState());
      if (res.enabled) setReloadKey((k) => k + 1);
      toast[res.enabled ? "success" : "error"](t(res.enabled ? "push.enabled" : `push.${res.reason}`));
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  const blocked = state === "denied" || state === "unsupported" || state === "ios_install";
  return (
    <div className="neu-in rounded-2xl p-4" data-testid="web-push-row">
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <BellRing className="h-4 w-4 text-primary" />
          <div>
            <p className="text-sm font-bold">{t("push.title")}</p>
            <p className="text-xs text-muted-foreground" data-testid="web-push-state">
              {t(`push.state.${state}`)}
            </p>
          </div>
        </div>
        <NeuButton
          variant="primary"
          className={`flex w-full items-center justify-center gap-2 px-4 py-2.5 text-xs sm:w-auto sm:px-5 ${state === "granted" ? "bg-sky-500" : "bg-emerald-500"}`}
          disabled={busy || blocked}
          data-testid={state === "granted" ? "web-push-refresh" : "web-push-enable"}
          onClick={enable}
        >
          {state === "granted" ? <RefreshCw className="h-3.5 w-3.5" /> : <BellRing className="h-3.5 w-3.5" />}
          {t(state === "granted" ? "push.refresh" : "push.enable")}
        </NeuButton>
      </div>
      {state === "unsupported" || state === "ios_install" ? (
        <p className="mt-2 text-[11px] text-muted-foreground" data-testid="web-push-hint">
          {t(state === "ios_install" ? "push.iosHint" : "push.browserHint")}
        </p>
      ) : null}
      <PushTestButton reloadKey={reloadKey} />
    </div>
  );
};
